import { FullscreenHtml } from '@components/helpers'
import { useDebug, useIsTouch } from '@hooks'
import { useThree } from '@react-three/fiber'
import clsx from 'clsx'
import { useEffect } from 'react'

import { useGameStore } from '@stores'

export function WidthWarning() {
  const debug = useDebug()
  const isTouch = useIsTouch()
  const { viewport } = useThree()
  const visible = viewport.aspect < 1
  const setPaused = useGameStore(state => state.setPaused)

  useEffect(() => {
    setPaused(!debug && visible)
  }, [visible, debug, setPaused])

  if (debug) return null

  return (
    <FullscreenHtml>
      <div
        className={clsx(
          'pointer-events-none absolute inset-0 z-10 flex flex-col items-center justify-center bg-black text-center text-2xl text-white transition-opacity duration-500',
          visible ? 'opacity-100' : 'opacity-0',
        )}
      >
        {isTouch ? (
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M9 1H3a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2m0 14H3V3h6zm12-2h-8v2h8v6H9v-1H6v1a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2m2-3l-4-2l1.91-.91A7.52 7.52 0 0 0 14 2.5V1a9 9 0 0 1 9 9"
              strokeWidth="0.5"
              stroke="currentColor"
            />
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="m9.5 13.09l1.41 1.41l-4.5 4.5H10v2H3v-7h2v3.59zm1.41-3.59L9.5 10.91L5 6.41V10H3V3h7v2H6.41zm3.59 3.59l4.5 4.5V14h2v7h-7v-2h3.59l-4.5-4.5zM13.09 9.5l4.5-4.5H14V3h7v7h-2V6.41l-4.5 4.5z"
              strokeWidth="0.5"
              stroke="currentColor"
            />
          </svg>
        )}

        <p>{isTouch ? 'Rotate your phone' : 'Resize your window'}</p>
      </div>
    </FullscreenHtml>
  )
}
